import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';

type ErrorMessageProps = {
  message?: string;
};
const ErrorMessage: React.FC<ErrorMessageProps> = ({ message = 'Something went wrong.' }) => {
  return (
    <div className={'flex flex-col justify-center items-center h-full w-full gap-4'}>
      <ErrorIcon fontSize='large' className={'!text-lynch-900'} />
      <p className={'text-center text-lg text-lynch-900'}>{message}</p>
    </div>
  );
};

export default ErrorMessage;
